module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-metals.6e4da913.png";